export class ValidateUserRequest {
    public username: string;
    public memberid: string;
    public clientid: string;
}
